export default "__VITE_ASSET__DjWYv0ff__"